var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_c('div',{staticClass:"warning-box",class:{
      neutral: _vm.theme === 'neutral',
      clickable: !!_vm.onClick,
    },on:{"click":_vm.handleOnClick}},[_c('span',{staticClass:"icon-warning"}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }